import { BaseLocation, baseLocationToString } from "../subscription/base-locations.enum";

export interface Rack {
  bay: string;
  city?: BaseLocation;
  number: string;
  row: string;
}

export const stagingBay = "Staging";

export function isRack(input: object): input is Rack {
  return "bay" in input && "number" in input && "row" in input;
}

export function rackToString(
  rack: { bay: string | null; city?: BaseLocation; number: string | null; row: string | null } | null | undefined,
): string {
  if (!rack || !isRack(rack)) {
    return "None";
  }

  let bay = rack.bay;
  if (bay === stagingBay) {
    bay = "Sta";
  }

  if (!bay && !rack.row && !rack.number) {
    return "None";
  }

  const city = rack.city ? `(${baseLocationToString(rack.city)})` : "";

  return `${bay ?? "None"} - ${rack.row ?? "None"} ${rack.number ?? "None"} ${city}`;
}

export function normalizeRack(rack: Rack): Rack {
  rack.bay = rack.bay?.toString();
  rack.number = rack.number?.toString();
  rack.row = rack.row?.toString();

  return rack;
}
